<app-cep-tablet [cameraUrl]="cameraUrl"></app-cep-tablet>
